import type { ServiceLanguage } from "@albertine/i18n";
import type {
    CatalogItemEditableTranslationKeys,
    CatalogItemTranslationServiceLanguageKeys,
} from "../types/Translation";
import { capitalize } from "./string.util";

export function getCatalogItemTranslationKey(
    baseKey: CatalogItemEditableTranslationKeys,
    serviceLanguage: ServiceLanguage,
): CatalogItemTranslationServiceLanguageKeys {
    return `${baseKey}${serviceLanguage === "en" ? "" : capitalize(serviceLanguage)}`;
}
